import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
import { clsx } from 'clsx';

interface StatsCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
  };
  icon: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  change,
  icon: Icon,
  iconColor = 'text-primary-600',
  iconBgColor = 'bg-primary-100',
}) => {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center">
          <div className={clsx('p-3 rounded-lg', iconBgColor)}>
            <Icon className={clsx('h-6 w-6', iconColor)} />
          </div>
          <div className="ml-4 flex-1">
            <p className="text-sm font-medium text-secondary-600">{title}</p>
            <p className="text-2xl font-semibold text-secondary-900">{value}</p>
            {change && (
              <p
                className={clsx(
                  'text-sm font-medium',
                  change.type === 'increase'
                    ? 'text-success-600'
                    : 'text-danger-600'
                )}
              >
                {change.type === 'increase' ? '+' : '-'}
                {Math.abs(change.value)}%
              </p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
